<template>
  <div
    ref="wrapper"
    :style="{
      display: 'block',
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
      background: placeholderBg,
    }"
  >
    <!-- 当使用 elImage 时 -->
    <el-image
      v-if="useEl"
      v-show="isLoaded"
      :src="realSrc"
      :fit="fit"
      :style="style"
      @load="onLoad"
      @error="onError"
    >
      <template #error>
        <slot name="error">
          <div style="text-align:center;color:#999;">加载失败</div>
        </slot>
      </template>
    </el-image>

    <!-- 当使用原生 img 时 -->
    <img
      v-else
      v-show="isLoaded"
      :src="realSrc"
      :alt="alt"
      :style="style"
      @load="onLoad"
      @error="onError"
    />

    <!-- 占位符（图片未加载前） -->
    <div
      v-if="!isLoaded"
      style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#aaa;"
    >
      <slot name="loading">
        <span>加载中...</span>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
  src: { type: String, required: true },
  useEl: { type: Boolean, default: false }, // 是否使用 el-image
  fit: { type: String, default: 'cover' },
  alt: { type: String, default: '' },
  style: { type: Object, default: () => ({ width: '100%', height: '100%' }) },
  placeholderBg: { type: String, default: '#f5f5f5' },
})

const isLoaded = ref(false)
const realSrc = ref('')
const wrapper = ref(null)
let observer = null

const onLoad = () => {
  isLoaded.value = true
}

const onError = () => {
  console.warn('图片加载失败:', props.src)
}

onMounted(() => {
  // 使用 IntersectionObserver 懒加载
  observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      realSrc.value = props.src
      observer.disconnect()
    }
  })

  if (wrapper.value) observer.observe(wrapper.value)
})

onBeforeUnmount(() => {
  if (observer) observer.disconnect()
})
</script>
